import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../../app/appConstants";

export const TutorialIntroModalContentStyled = styled.div`
    width: 100%;
    height: 480px;
    justify-content: center;
    align-items: center;
    background: #0A0A10;
    display: flex;
    position: relative;
    cursor: pointer;

    h1 {
        font-weight: 700;
        font-size: 48px;

    }
`;

export const TutorialIntroModalInnerWrapperStyled = styled.div`
    width: 40%;
    margin: 0 auto;
    display: flex;
    @media (max-width: ${BREAKPOINTS.large}px) {
        width: 50%;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        width: 70%;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        width: 90%;
    }
`;

export const TutorialIntroModalLeftContainer = styled.div`
    margin-right: 32px;
`;

export const TutorialIntroModalWatchLaterFooterStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px 12px 32px;
    
    button {
        flex: 0 0 auto;
        margin-left: 32px;
    }
`;

export const TutorialIntroModalCloseButtonStyled = styled.div`
    position: absolute;
    top: -40px;
    right: -40px;
    cursor: pointer;

    svg {
        fill: var(--icon-primary-color);
    }

    &:hover {
        svg {
            fill: var(--color-white);
        }
    }

    @media (max-width: ${BREAKPOINTS.small}px) {
        right: 0;
    }
`;
